import {
    HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse,
    HttpProgressEvent, HttpResponse, HttpUserEvent
} from "@angular/common/http";
import { Observable } from "rxjs";
import { LookupService } from "../services/lookup.service";
import { Injectable } from "@angular/core";

@Injectable()
export class RequestSanitizerInterceptor implements HttpInterceptor {
    constructor(private lookupService: LookupService) {

    }

    intercept(req: HttpRequest<any>, next: HttpHandler):
        Observable<HttpSentEvent |
        HttpHeaderResponse |
        HttpProgressEvent |
        HttpResponse<any> |
        HttpUserEvent<any>> {
        if (req.method === "POST") {
            let reqClone: HttpRequest<any> = req.clone();

            if (req.body) {
                Object.keys(req.body).forEach((prop) => {
                    if ((req.body[prop] !== undefined && req.body[prop] !== null) && this.isObjectEmpty(req.body[prop])) {
                        reqClone.body[prop] = undefined;
                    }
                });
            }

            return next.handle(reqClone);
        }

        return next.handle(req);
    }

    private isObjectEmpty(object: any): boolean {
        let objKeys: string[] = Object.keys(object);

        if (objKeys.length) {
            for (const key of objKeys) {
                if (object[key] && typeof object[key] === "object") {
                    return this.isObjectEmpty(object[key]);
                } else {
                    if (object[key]) {
                        return false;
                    }
                }
            }
            return true;
        }

        return false;
    }
}